import { autobind } from 'core-decorators';
import { Component } from 'react';
import PlantingDatesTable from '/@/components/planting-dates-table';
import { _, _lazy } from '/@/locale';
import styles from './styles.module.css';

@autobind
export default class SoyPlantingDates extends Component {
    static icon = 'plantingDates';
    static label = _lazy('Fecha de siembra y densidad');

    render() {
        const { cropConfig, productRecommendations } = this.props;

        return (
            <div className={styles.root}>
                <p>
                    {_(
                        'Datos promedio de densidad: para un mejor posicionamiento, comuníquese con un agrónomo especialista en su región.'
                    )}
                </p>
                <PlantingDatesTable
                    plantingDate={cropConfig.plantingDate}
                    products={productRecommendations}
                    showDensity
                >
                    {({ renderPlantingDatesHeader, renderPlantingDatesRow, renderPlantingDatesReferences }) => (
                        <div className={styles.root}>
                            <div className={styles.header}>{renderPlantingDatesHeader()}</div>
                            {productRecommendations.map((productRecommendation) => (
                                <div key={productRecommendation.id} className={styles.row}>
                                    <div className={styles.product}>{productRecommendation.profile.product.name}</div>
                                    {renderPlantingDatesRow(productRecommendation)}
                                </div>
                            ))}
                            {renderPlantingDatesReferences()}
                        </div>
                    )}
                </PlantingDatesTable>
            </div>
        );
    }
}
